export default __webpack_public_path__ + "static/media/download.1b4d343f.svg";